import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import remarkGfm from 'remark-gfm';
import DismissAllWebp from 'images/help/dismiss_all.webp';
import Label from 'layout/atoms/Label';
import PageGuideCard from 'molecules/PageGuideCard/PageGuideCard';
import styles from './PageGuideDismissedTemplate.module.scss';
const markdownComponents = {
    a: ({ href, children }) => (href === null || href === void 0 ? void 0 : href.startsWith('/')) ? (React.createElement(Link, { to: href }, children)) : (React.createElement("a", { href: href, target: "_blank", rel: "noopener noreferrer" }, children)),
};
// Takes PageGuideTemplate's spot (same PageGuideCard slot in
// PageGuideManager) right after "Pomiń wszystkie" is clicked, to explain how
// to bring the guide back. The illustration is a placeholder - swap
// `dismiss_all.webp` for a real image/gif whenever one is ready, no code
// changes needed.
function PageGuideDismissedTemplate({ onOpenHelpCenter, onClose, }) {
    const { t } = useTranslation('pageGuides');
    return (React.createElement(PageGuideCard, { buttons: [
            { label: t('DISMISS_ALL_INFO_HELP_CENTER'), onClick: onOpenHelpCenter, color: 'secondary' },
            { label: t('DISMISS_ALL_INFO_CONFIRM'), onClick: onClose, color: 'primary' },
        ] },
        React.createElement("img", { className: styles.illustration, src: DismissAllWebp, alt: "" }),
        React.createElement(Label, { color: "normal", size: "s" }, t('DISMISS_ALL_INFO_TITLE')),
        React.createElement(ReactMarkdown, { remarkPlugins: [remarkGfm], components: markdownComponents }, t('DISMISS_ALL_INFO_BODY'))));
}
export default PageGuideDismissedTemplate;
